import { Component, EventEmitter, Input, Output, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase, LocationInfo } from 't4core';


@Component({
    selector: 't4-location-link',
    templateUrl: './locationLink.html',
    styleUrls: ['./locationLink.css'],
})
export class T4LocationLink extends ComponentBase {
    private _locationId: number;
    public get locationId(): number { return this._locationId; }
     @Input() public set locationId(value: number|null) {
        if (!value) return;

        var val = parseInt(value.toString());
       if (this._locationId != val) {
         this._locationId = val;
         if (this.content.nativeElement.childNodes.length == 0) this.loadLocation();
            this.location = undefined;
        }
    };

    @Output() public mouseOver = new EventEmitter<LocationInfo>();
    @Output() public mouseOut = new EventEmitter<LocationInfo>();
    @Output() public clicked = new EventEmitter<LocationInfo>();


  @ViewChild("ref", { static: true }) public content: ElementRef;

    public location: LocationInfo;
    public isLoading: boolean = false;
    public displayTooltip: boolean = false;
    public hidingTooltip: boolean = false;

    constructor(private route: Router, private activeRoute: ActivatedRoute) {
        super();
    }

    private loadLocation() {
        this.isLoading = true;

      this.Api.get<LocationInfo>("Location/GetLocationInfo", { locationId: this._locationId }).then(x => {
            this.location = x;
            this.mouseOver.emit(this.location);
        });
    }

    public show() {
        this.hidingTooltip = false;
        this.displayTooltip = true;
        if (!this.location) {
            this.loadLocation();
        } else {
            this.mouseOver.emit(this.location);
        }
    }

    public hide() {
        this.hidingTooltip = true;
        setTimeout(() => {
            if (this.hidingTooltip) {
                this.displayTooltip = false;
                this.mouseOut.emit(this.location);
            }
        }, 100);
    }

    public async open() {
        this.clicked.emit(this.location);
    }
}
